<template>
  <div :id="id" class="halfcut-diag"></div>
  <img
    class="halfcut-bg"
    src="@/assets/images/halfcut-bg.svg"
    alt="#"
    v-if="theme == 'light'"
  />
  <img
    class="halfcut-bg"
    src="@/assets/images/halfcut-bg.svg"
    alt="#"
    v-if="theme == 'medium'"
  />
  <img
    class="halfcut-bg"
    src="@/assets/images/halfcut-bg-dark.svg"
    alt="#"
    v-if="theme == 'dark'"
  />
</template>

<script>
import store from "@/store";
import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
highchartsMore(Highcharts);
solidGauge(Highcharts);

export default {
  name: "HalfCutProgressV3",
  props: ["id", "color", "data","title"],
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
  },
  updated() {
    this.renderChart();
  },
  mounted() {
    this.renderChart();
    document
      .querySelectorAll(".highcharts-credits")
      .forEach((item) => (item.style.display = "none"));
  },
  methods: {
    renderChart: function () {
      Highcharts.chart(this.id, {
        chart: {
          type: "solidgauge",
          height: "155px",
          width: 166,
          backgroundColor: "transparent",
        },
        title: "",
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              outerRadius: "100%",
              innerRadius: "100%",
              backgroundColor:
                this.theme == "light" || this.theme == "medium"
                  ? "#E7E7E7"
                  : "rgba(255, 255, 255, 0.13)",
              borderWidth: 0,
            },
          ],
          size: "63%",
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },

        plotOptions: {
          solidgauge: {
            center: ["50%", "50%"],
          },
        },

        series: [
          {
            animation: {
              duration: 1500
            },
            name: this.title,
            borderWidth: 4,
            zIndex: 10,
            borderColor:
              this.theme == "light" || this.theme == "medium"
                ? "#fff"
                : "#071D1D",
            tooltip: {
              pointFormat: '<b>{point.y}</b>:{series.name}<br/>',
              valueSuffix: '% ',
            },
            data: [
              {
                color: this.color,
                radius: "120%",
                innerRadius: "100%",
                y: parseInt(this.data.toFixed(0)),
                className: "bgblur",
                
                

                dataLabels: {
                  enabled: true,
                  align: "center",
                  verticalAlign: "middle",
                  y: -5,
                  x: 4,
                  format:
                    "<div style='font-family:Source Sans Pro,sans-serif; font-size: 20px; font-weight:700'>{y}%</div>",
                  borderWidth: 0,
                  className: "cust-label",
                  style: {
                    fontSize: "24px",
                    color:
                      this.theme == "light" || this.theme ? "#B7B471" : "#fff",
                  },
                },
              },
            ],
          },
        ],
      });
      document
        .querySelectorAll(".highcharts-credits")
        .forEach((item) => (item.style.display = "none"));
    },
  },
};
</script>

<style lang='scss'>
body.theme-light {
  .ch {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
body.theme-medium {
  .ch {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
body.theme-dark {
  .ch {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>

<style lang='scss' scoped>
body.theme-light {
  .ch {
    .halfcut-bg {
      position: absolute;
      top: 38px;
      z-index: 0;
    }
    .highcharts-container {
      width: 166px !important;
    }
  }
  .halfcut-diag {
    margin: 0 auto;
    padding-top: 5px;
    z-index: 10;
    .cust-label {
      margin-top: 10px;
      transform: "translate(30,55)" !important;
    }
  }
  .bgblur {
    box-shadow: 0px 4px 47px rgba(9, 191, 195, 0.55);
  }
}
body.theme-medium {
  .ch {
    .halfcut-bg {
      position: absolute;
      top: 38px;
      z-index: 0;
      
    }
    .highcharts-container {
      width: 166px !important;
    }
  }
  .halfcut-diag {
    margin: 0 auto;
    padding-top: 5px;
    margin-top: 5px;
    z-index: 10;

    .cust-label {
      margin-top: 10px;
      transform: "translate(30,55)" !important;
    }
  }
  .bgblur {
    box-shadow: 0px 4px 47px rgba(9, 191, 195, 0.55);
  }
}
body.theme-dark {
  .ch {
    .halfcut-bg {
      position: absolute;
      top: 38px;
      z-index: 0;
    }
    .highcharts-container {
      width: 166px !important;
    }
  }
  .halfcut-diag {
    margin: 0 auto;
    padding-top: 5px;
    z-index: 10;

    .cust-label {
      margin-top: 10px;
      transform: "translate(30,55)" !important;
    }
  }
}
</style>